import React, { useState } from "react";
import TownPlanningSidebar from "../components/TownPlanningSidebar";
import styles from "../styles/TownPlanningDashboard.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { FaArrowLeft, FaSearch, FaDownload, FaFilter, FaCalculator, FaFilePdf } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
export default function Objectives() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
const navigate = useNavigate();
  const handleBack = () => {
    navigate("/")
  };
  return (
    <div
      className={styles.homeScreenContainer}
      style={{
        height: "100vh",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Header */}
      <div className={styles.homeScreenHeader}>
        {/* <button
          onClick={() => setIsSidebarOpen(true)}
          className={styles.homeScreenMenuBtn}
        >
          <FontAwesomeIcon icon={faBars} />
        </button> */}

        <button className={styles.homeScreenMenuBtn} onClick={handleBack}>
          <FaArrowLeft />
        </button>

        
        <TownPlanningSidebar
          isOpen={isSidebarOpen}
          onClose={() => setIsSidebarOpen(false)}
        />

        <h2 style={{ color: "white" }}>Objectives</h2>
      </div>

      {/* Scrollable Content Area */}
      <div
        style={{
          flex: 1,
          overflowY: "auto",
          padding: "20px",
          color: "white",
        }}
      >
 
 {/* <p style={{ textAlign: "justify" }}>
  We welcome you to the amazing and creative world of Town Planning. This app is designed to support town planning officers, citizens, and stakeholders engaged in urban development across Maharashtra. The app serves as a comprehensive resource, offering general and technical information, documents including ACTS, RULES, COURT ORDERS, DIRECTIVES, GR and legal provisions relevant to daily office work. It aims to simplify access to essential documents and guidelines, ensuring efficiency and clarity as well as to bring uniformity in practices for officers in government departments. Beyond administration, the app is equally valuable for civil engineers, architects, urban planners, and academic professionals, fostering informed decision-making and knowledge sharing in the field of sustainable urban development. This is a non-profit initiative to help town planning community and strive to achieve ATMANIRBHAR TOWN PLANNING.
</p> */}

<ul style={{ textAlign: "justify", paddingLeft: "20px" }}>
  <li>
    We welcome you to the amazing and creative world of Town Planning.
  </li>

  <li>
    This app is designed to support town planning practitioners, citizens, and agencies interested in the field of sustainable urban development across Maharashtra State.
  </li>

  <li>
    The app serves as a forum for publicly available resources and relevant documents, offering general and technical information.
  </li>

  <li>
    It aims to simplify access to publicly available documents and guidelines, ensuring efficiency and clarity, as well as to create awareness among the general public by providing a compilation of publicly available information in one place.
  </li>

  <li>
    This app is also valuable for civil engineers, architects, urban planners, and academic professionals, fostering informed decision-making, knowledge sharing, and contributing to the field of sustainable urban development.
  </li>

  <li>
    This is a non-profit initiative dedicated to supporting the town planning community and striving to achieve <strong>ATMANIRBHAR TOWN PLANNING</strong>.
  </li>
</ul>


      </div>
    </div>
  );
}
